export const ProductListData = {
  total_records: 3,
  totalPages: 1,
  current_page: 0,
  page_size: 10,
  items: [
    {
      productId: '000000000300016528',
      status: 'Active',
      productName: '7UP LEMLIM CAN 330ML 1PK24CS SLK',
      displayNameEnglish: '7UP Sleek Can 1/24',
      subcategoryEnglish: 'Carbonated & Ice Tea',
      sorting: '339',
      showOnECommerce: 'Yes',
      suggestedProductSellingPrice: '5',
      multipleSellingUnits: '2x',
    },
    {
      productId: '000000000300016492',
      status: 'Inactive',
      productName: 'MTN DEW CIT PET 850ML 1PK15CS R',
      displayNameEnglish: 'MOUNTAIN DEW PET 1/15',
      subcategoryEnglish: 'Carbonated & Ice Tea',
      sorting: '449',
      showOnECommerce: 'Yes',
      suggestedProductSellingPrice: '5',
      multipleSellingUnits: '2x',
    },
    {
      productId: '000000000300016492',
      status: 'Active',
      productName: 'MTN DEW CIT PET 850ML 1PK15CS R',
      displayNameEnglish: 'LIPTON LEMON ZERO PET 1/12',
      subcategoryEnglish: 'Carbonated & Ice Tea',
      sorting: '665',
      showOnECommerce: 'No',
      suggestedProductSellingPrice: '5',
      multipleSellingUnits: '2x',
    },
  ],
}
